<template>
  <div class="table-action-wrapper update-order-costs" ref="container">
    <div class="position-relative d-flex flex-wrap w-100">
      <Select :options="Object.values(updateOrderCosts)" data-title="Action" class="has-tip d-inline-block mr-2" placeholder="Action" v-model="action" style="width: 200px"></Select>
      <label for="uploadFile" class="btn btn-outline-success d-flex align-items-center mb-0 mr-2">
        <input id="uploadFile" type="file" @change="changeFile" style="display: none" />
        <span>Choose File</span>
      </label>
      <a @click.prevent="submit" href="#" class="btn btn-outline-success d-flex align-items-center mb-0 mr-2">
        <span>Submit</span>
      </a>
      <div class="w-100 mt-1">
        <span v-if="errorIds.length == 0">Selected: {{ Object.keys(orders).length }} items</span>
        <div v-else class="error text-danger mt-2">
          {{ errorIds.join(', ') }}
        </div>
      </div>
      <small class="w-100">If you don't have the template, please <a @click.prevent="clickDownloadTemplate" href="#">download it here</a>.</small>
    </div>
  </div>
</template>
<script>
import { read, utils, writeFileXLSX } from 'xlsx'
export default {
  data() {
    return {
      action: '',
      orders: [],
      errorIds: [],
      header: {
        total_price: ['Order ID*', 'Total Price*'],
        shipping_cost: ['Order ID*', 'Shipping Cost*']
      }
    }
  },
  computed: {
    store() {
      return this.config?.store
    },
    extraAttributes() {
      return this.config?.extraAttributes || {}
    },
    updateOrderCosts() {
      return this.extraAttributes?.update_order_cost || {}
    }
  },
  methods: {
    clickDownloadTemplate() {
      let workbook = utils.book_new()
      if (!Object.keys(this.header).includes(this.action)) {
        alert('Only xlsx format is supported')
      }
      /* prettier-ignore */
      let worksheet = utils.aoa_to_sheet([this.header[this.action]])
      utils.book_append_sheet(workbook, worksheet, 'Index')
      writeFileXLSX(workbook, `OrderCost-${new Date().getTime()}.xlsx`)
    },
    async changeFile(e) {
      const file = e.target.files[0]
      if (!/\.(xlsx|xls|csv)$/i.test(file.name)) {
        alert('Please select the action!')
        return
      } else if (!Object.keys(this.header).includes(this.action)) {
        alert('Only xlsx format is supported')
        return
      }
      let wb = read(await file.arrayBuffer())
      let data = utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]])
      this.orders = []

      for (let i = 0; i <= data.length; i++) {
        if (!data[i]?.[this.header[this.action][0]]) continue
        this.orders.push({
          id: String(data[i][this.header[this.action][0]]).replace('#', ''),
          price: data[i][this.header[this.action][1]]
        })
      }
      e.target.value = ''
    },
    submit() {
      this.$util
        .post(
          '/order/more/update-order-costs',
          {
            action: this.action,
            orders: this.orders
          },
          this.$refs.container
        )
        .then((response) => {
          if (response.status == 'success') {
            let alerts = []
            Object.entries(response.orders).forEach(([id, object]) => {
              if (object.status != 'success' && object?.msg) {
                alerts.push(`Order ${object.id}: ${object?.msg}`)
              }
            })
            this.$util.notify({
              text: alerts.length > 0 ? alerts.join('\n') : 'Update successful!',
              status: alerts.length > 0 ? 'error' : 'success'
            })
          }
        })
    }
  },
  watch: {
    action() {
      this.orders = []
    }
  },
  props: {
    config: Object
  }
}
</script>

<style lang="scss">
.update-order-costs {
  .error.text-danger {
    max-height: 400px;
    overflow: auto;
  }
}
</style>
